/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/free-mode";
import "./Activities.css";
import activity1 from "./../assets/images/activity/activity-1.png";
import activity2 from "./../assets/images/activity/activity-2.png";
import activity3 from "./../assets/images/activity/activity-3.png";
import activity4 from "./../assets/images/activity/activity-4.png";
import activity5 from "./../assets/images/activity/activity-5.png";
import { Fade } from "react-reveal";

export default function Activities() {
  return (
    <div id="activities">
      <div className="activitySec container-fluid">
        <Fade bottom>
          <div className="activityDiv">
            <h3>الانشطة</h3>
            <div className="activityContent">
              <Swiper
                slidesPerView={1}
                spaceBetween={20}
                autoplay
                navigation
                freeMode={true}
                loop={true}
                pagination={{
                  clickable: true,
                }}
                modules={[Navigation, FreeMode, Pagination]}
                breakpoints={{
                  576: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  767: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                  },
                }}
                className="swiper-container"
              >
                <SwiperSlide>
                  <div
                    className="activityCard"
                    style={{ backgroundImage: `url(${activity1})` }}
                  ></div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className="activityCard"
                    style={{ backgroundImage: `url(${activity2})` }}
                  ></div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className="activityCard"
                    style={{ backgroundImage: `url(${activity3})` }}
                  ></div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className="activityCard"
                    style={{ backgroundImage: `url(${activity4})` }}
                  ></div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className="activityCard"
                    style={{ backgroundImage: `url(${activity5})` }}
                  ></div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
}
